import { Text, Box, VStack, Flex, useTheme } from '@wegroup/design-system';
import React from 'react';
import RadioButton from '../../../flows/src/components/ui/advisory-flow/components/shared-components/RadioButton';

interface Props {
  Illustration: React.ReactElement;
  text: React.ReactNode;
  description?: string;
  isSelected: boolean;
  onClick: () => void;
  dataTestId?: string;
}

const IllustrationRadioButton: React.FC<React.PropsWithChildren<Props>> = ({
  Illustration,
  text,
  description,
  isSelected,
  onClick,
  dataTestId = 'COMMON_COMPONENTS_ILLUSTRATED-RADIO-BUTTON_WRAPPER',
}) => {
  const { colors } = useTheme();

  return (
    <VStack
      alignItems="center"
      flexDir="column"
      maxW="80"
      spacing="4"
      onClick={onClick}
      _hover={{ cursor: 'pointer' }}
      data-test-id={dataTestId}
    >
      <Box
        h={{ base: '32', tablet: '40', laptop: '52', desktop: 'auto' }}
        display={{ base: 'none', mobileL: 'flex' }}
        sx={{ svg: { transition: '0.2s', w: '100%', h: '100%' } }}
      >
        {Illustration}
      </Box>
      <Text
        align="center"
        textStyle="h4Headline"
        color="gray.300"
        as="h4"
        sx={{
          'p > span': {
            transition: '0.2s',
            color: isSelected ? colors.primary[500] : '#222',
          },
        }}
      >
        {text}
      </Text>
      {description && (
        <Text
          align="center"
          mb={{ base: '4', mobileL: '10' }}
          textStyle="normalBody"
          color="gray.400"
        >
          {description}
        </Text>
      )}
      <Flex alignItems="flex-end" flexShrink={0}>
        <RadioButton isSelected={isSelected} />
      </Flex>
    </VStack>
  );
};

export default IllustrationRadioButton;
